// Constants
import { Endpoints } from "~constants/endpoints"

// Utils
import { Api } from "~utils/api"

// Shapes
import { RolesListShape } from "~shapes/role"

const RolesService = {
  getRoles: async () => {
    const path = Endpoints.ROLES.URL
    const response = await Api.get(path)
    return response.data as RolesListShape
  },
}

export default RolesService
